import { c as _c } from "react/compiler-runtime";
interface PriceInfoProps {
  amount: number;
}
export const PriceInfo = t0 => {
  const $ = _c(8);
  const {
    amount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="font-400 text-Gray-900 typo-body4">기부 금액</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== amount) {
    t2 = amount.toLocaleString();
    $[1] = amount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex items-center justify-between gap-16">{t1}<p className="font-700 text-O-400 typo-h3 mobile-tablet:typo-h5">{t2}원</p></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center justify-between gap-16"><p className="font-400 text-Gray-900 typo-body4">답례품</p><p className="font-400 text-Gray-600 typo-body4">무료 증정</p></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="flex flex-col gap-4">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};